import '../scss/admin.scss';

const $ = jQuery;

window.SP = {};
window.SP.insertedIds = [];
window.SP.listeners = false;

const SPlog = (log) => {
    if (stockpress_js_object.debug) {
        console.log(log);
    }
}

const setLocked = (locked) => {
    if (locked) {
        $('.stockpress-tab-content').addClass('locked');
        $('.stockpress-tab-lock-overlay').show();
    } else {
        $('.stockpress-tab-content').removeClass('locked')
        $('.stockpress-tab-lock-overlay').hide();
    }
};

const uploadFile = async (file) => (
    await $.ajax({
        url: `${stockpress_js_object.rest_url}/upload`,
        type: 'post',
        data: { file, post_id: wp.media.view.settings?.post?.id || 0 },
        beforeSend: function(xhr) {
            xhr.setRequestHeader('X-WP-Nonce', stockpress_js_object.nonce);
        },
    })
);

const handleInsertFile = async (file) => {
    setLocked(true);
    const response = await uploadFile(file);
    setLocked(false);
    if (response.id) {
        window.SP.insertedIds = [response.id];
        $('#menu-item-browse').click();
    }
};

const handleUploadFile = async (file) => {
    setLocked(true);
    await uploadFile(file);
    setLocked(false);
};

const handleEvents = async (event, data) => {
    switch (event) {
        case 'insert':
            await handleInsertFile(data);
            break;
        case 'upload':
            await handleUploadFile(data);
            break;
        default:
            break;
    }

    SPlog('Event');
    SPlog(event);
    if (data) {
        SPlog(data);
    }
};

window.SP.handleEvents = handleEvents;

// Get Media Library modal element
const getMediaLibrary = () => {
    if (wp.media.frame.content.get('gallery')) {
        return wp.media.frame.content.get('gallery');
    }
    if (acf && acf.media) {
        return acf.media.frame().content.get();
    }
};

const getMediaState = () => {
    if (wp.media.frame.state()) {
        return wp.media.frame.state();
    }
    if (acf && acf.media) {
        return acf.media.frame().state();
    }
};

const initStockpressMini = () => {
    document.getElementById('stockpress-mini').innerHTML = '';
    SPMini.init('stockpress-mini', {
        integrationId: 'wordpress',
        theme: 'wordpress',
        wordpressPluginApiUrl: stockpress_js_object.plugin_api_url,
        wordpressPluginVersion: stockpress_js_object.plugin_version,
        wordpressPluginBackUrl: stockpress_js_object.plugin_back_url,
        authToken: window.SP.auth_token || stockpress_js_object.auth_token,
        wordpressExternalUserToken: stockpress_js_object.external_user_token,
        handleEvents: window.SP.handleEvents,
    });
}

// Selecting file from Stockpress on Media Library tab
const setListeners = () => {
    if (!(wp && wp.media) || window.SP.listeners) {
        return;
    }

    SPlog('setListeners');

    window.SP.listeners = true;

    // Reload Media Library every time it opens with files to select
    wp.media.view.Attachments.prototype.on('ready',function() {
        if (window.SP.insertedIds.length > 0) {
            if (wp?.ajax?.settings?.url) {
                wp.ajax.settings.url = wp.ajax.settings.url + '?inserted_ids=' + window.SP.insertedIds.join(',');
            }
            getMediaLibrary().collection._requery(true);
            getMediaLibrary().options.selection.reset();
        }
    });

    wp.media.view.Attachments.prototype.on('ready',function() {
        SPlog(getMediaLibrary());

        getMediaLibrary().collection.on('attachments:received', function() {
            if (this.length === 0) {
                return;
            }

            if (window.SP.insertedIds.length > 0) {
                const select = getMediaState().get('selection');
                window.SP.insertedIds.forEach(function(id) {
                    const image = wp.media.attachment(id);
                    SPlog('Selecting file')
                    SPlog(id);
                    SPlog(image);
                    if (image) {
                        select.add([image]);
                    }
                });
                window.SP.insertedIds = [];
            }
        });
    });
};

// Media modal tab
const initMediaModalTab = () => {
    if (!(wp && wp.media)) {
        return;
    }

    const stockpressFrame = {
        initialize: function () {
            frame.prototype.initialize.apply(this, arguments);

            const State = wp.media.controller.State.extend({
                insert: function () {
                    this.frame.close();
                },
            });

            this.states.add([
                new State({
                    id: 'stockpress',
                    search: false,
                    title: 'Stockpress',
                }),
            ]);

            this.on(
                'content:render:stockpress',
                this.renderStockpressTabContent,
                this,
            );
        },
        browseRouter: function (routerView) {
            routerView.set({
                upload: {
                    text: l10n.uploadFilesTitle,
                    priority: 20,
                },
                browse: {
                    text: l10n.mediaLibraryTitle,
                    priority: 40,
                },
                stockpress: {
                    text: 'Stockpress',
                    priority: 60,
                },
            });
        },
        renderStockpressTabContent: function () {
            const StockpressTabContent = wp.Backbone.View.extend({
                tagName: 'div',
                className: 'stockpress-tab-content',
                template: wp.template('stockpress-tab-template'),
                active: false,
                toolbar: null,
                frame: null,
            });
            const view = new StockpressTabContent();
            this.content.set(view);

            setTimeout(() => {
                initStockpressMini();
            }, 100);
        },
    };

    const l10n = wp.media.view.l10n;
    let frame = null;
    frame = wp.media.view.MediaFrame.Post;
    wp.media.view.MediaFrame.Post = frame.extend(stockpressFrame);
    frame = wp.media.view.MediaFrame.Select;
    wp.media.view.MediaFrame.Select = frame.extend(stockpressFrame);
};

$(window).load(function() {
    setTimeout(() => {
        initMediaModalTab();
    }, 100);
});

// Set listeners for Media Library
$(window).load(function() {
    if (wp.media) {
        wp.media.view.Modal.prototype.on('open', function() {
            setListeners();
        });
    }

    $(document).on('click', '#menu-item-browse', function() {
        SPlog(window.SP.insertedIds);

        if (!window.SP.listeners) {
            setListeners();
        }
    });
});

// Settings page
$(document).ready(function($) {
    $('.stockpress-settings').on('click', 'button,input[type="submit"]', function() {
        $(this).addClass('disabled');
    });
});

// Connecting workspace
$(document).ready(function($) {
    if ($('.stockpress-settings-connect').length === 0) {
        return;
    }

    const attrs = {
        token: (new URLSearchParams(location.search)).get('token'),
    };
    $.ajax({
        url: `${stockpress_js_object.rest_url}/connection`,
        type: 'post',
        data: attrs,
        beforeSend: function(xhr) {
            xhr.setRequestHeader('X-WP-Nonce', stockpress_js_object.nonce);
        },
        complete: function() {
            $('.stockpress-settings-connect .loader-wrapper').hide();
        },
        success: function() {
            $('.stockpress-settings-connect .stockpress-connect-message').show();
        },
        error: function() {
            $('.stockpress-settings-connect .stockpress-connect-error-message').show();
        },
    });
});

// Getting connected user
$(document).ready(function($) {
    if ($('.stockpress-settings-connected').length === 0) {
        return;
    }

    $.ajax({
        url: `${stockpress_js_object.rest_url}/connection`,
        type: 'get',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('X-WP-Nonce', stockpress_js_object.nonce);
        },
        success: function(user) {
            SPlog(user);
            const el = $('.stockpress-settings-connected .stockpress-settings-connected-account');
            el.find('.stockpress-settings-connected-account-workspace').html(`<a href="${user.client.host}" target="_blank">${user.client.domain}</a>`);
            el.find('.stockpress-settings-connected-account-account').html(`${user.name} (${user.email})`);
            $('.stockpress-settings-connected .loading').hide();
            el.show();
        },
        error: function() {
            $('.stockpress-settings-connected .stockpress-connected-error-message').show();
        },
    });
});
